import {useParams, useRouteMatch} from 'react-router-dom';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {SeniorRelationshipInvitesHistory} from '../../../../../../../components/senior-relationship-invites-history/senior-relationship-invites-history';
import {useContext} from 'react';
import {CaregiverMode} from '../../../../../../../enums';

export default function SeniorInvitesHistoryProfessionalCaregiverOfficeScreen() {
  let {id, entityId}: {id: string; entityId: string} = useParams();
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <SeniorRelationshipInvitesHistory
      seniorId={id || ''}
      entityId={entityId}
      seniorName={officeContext.state.userForm?.user.name || ''}
      url={url}
      inviteCaregiverUrl={url.replace('/invites', '/invite')}
      caregiverMode={CaregiverMode.Professional}
    />
  );
}
